import { AppTranslationPipe } from '@adapter/i18n/app-translation.pipe';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
/**
 * Componente que define el layout de una página
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-page-layout',
  imports: [AppTranslationPipe],
  template: `
    <div class="p-6 min-h-full">
      <div class="flex flex-col">
        <div class="flex justify-between items-end mb-4">
          <span class="app-text-title text-primary pl-4">{{
            pageTitle() | translate
          }}</span>
          <ng-content select="[page-actions]"></ng-content>
        </div>
        <div class="flex-1">
          <ng-content select="[page-content]"></ng-content>
        </div>
      </div>
    </div>
  `,
  styles: ``
})
export class AppPageLayoutComponent {
  /**
   * Título de la página
   */
  pageTitle = input.required<string>();
}
